import React, { useState } from 'react';
import { TransProps } from '@lingui/react';
import {QuestionMarkCircleIcon} from "@heroicons/react/solid";

export type typeIconWithTitleByHover = {
    // iconElement: { icon: (props: React.ComponentProps<'svg'>) => JSX.Element },
    title: React.ReactElement<TransProps>,
    titleStyles?: string
}

export const IconWithTitleByHover: React.FC<typeIconWithTitleByHover> = ({
                                                                             titleStyles,
                                                                             title
                                                                         }) => {

    const [ showTitle, setShowTitle ] = useState(false)

    return (

        <div className={ 'relative' }
             onMouseEnter={ () => setShowTitle(true) }
             onMouseLeave={ () => setShowTitle(false) }
        >
            <div
                className={ `${ showTitle ? 'opacity-100 visible' : 'opacity-0 hidden' } transition-opacity duration-100 absolute -top-8 -left-4 min-w-max z-999 text-xs text-gray-500 font-medium rounded border border-gray-300 bg-gray-50 p-2 ${ titleStyles }` }>{ title }</div>

            <div className={'flex justify-center '}>
                <div className={ `rounded-full w-4 h-4 flex justify-center items-center ` }>
                    <div className={''}><QuestionMarkCircleIcon className={'h-4 w-4 text-gray-300 hover:text-gray-400'}/></div>
                    </div>
            </div>

        </div>
    );
}

export default IconWithTitleByHover;
